<template>
  <drag-dialog
    :append-to-body="true"
    :show.sync="dialog"
    :title="isAdd ? '新增定时任务' : '编辑定时任务'"
    :enableDrag="true"
    width="600px"
    @close="cancel">
    <dynamic-form :formConfig="formConfig" label-width="110px" v-model="form" @submit="doSubmit" @cancelForm="cancel" ref="pageForm"></dynamic-form>
  </drag-dialog>
</template>

<script>
import { add } from '@/api/monitor/task'
import DragDialog from '@/components/DragDialog'
import '@/components/dynamic-form'
export default {
  props: {
    isAdd: {
      type: Boolean,
      required: true
    },
    supThis: {
      type: Object,
    }
  },
  components: {
    DragDialog
  },
  watch: {
    dialog(val) {
        if (val) {
          const index = this.formConfig.formItemList.findIndex(i => i.key === 'status')
          if (this.isAdd) {
            this.$set(this.formConfig.formItemList[index], 'disabled', false)
          } else {
            this.$set(this.formConfig.formItemList[index], 'disabled', true)
          }
          this.$nextTick(() => {
            this.$refs.pageForm.$refs.dynamicForm.clearValidate();
          });
        }
    }
  },
  data() {
    return {
      loading: false, dialog: false,
      form: {},
      formConfig: {
        formItemList: [
            {
              type: "input",
              key: "name",
              label: "任务名称",
              value: "",
              placeholder: "请输入名称",
              rules: [
                  { required: true, message: "不能为空", trigger: "blur" }
              ]
            },
            {
              type: "input",
              key: "beanName",
              label: "Bean名称",
              value: "",
              placeholder: "请输入Bean名称",
              rules: [
                  { required: true, message: "不能为空", trigger: "blur" }
              ]
            },
            {
              type: "input",
              key: "methodName",
              label: "执行方法名称",
              value: "",
              placeholder: "请输入执行方法名称",
              rules: [
                  { required: true, message: "不能为空", trigger: "blur" }
              ]
            },
            {
              type: "input",
              key: "params",
              label: "方法参数",
              value: "",
              placeholder: "请输入方法参数，多个参数JSON格式",
            },
            {
              type: "input",
              key: "cronExpression",
              label: "Cron表达式",
              value: "",
              placeholder: "请输入Cron表达式",
              rules: [
                  { required: true, message: "不能为空", trigger: "blur" }
              ]
            },
            {
                label: '任务状态',
                key: 'status',
                type: 'select',
                multiple: false,
                value: '',
                disabled: !this.isAdd,
                options: [
                  {
                    label: '运行中',
                    value: 1
                  },
                  {
                    label: '暂停',
                    value: 0
                  }
                ],
                rules: {
                    required: true, message: '不能为空', trigger: 'change'
                }
            },
            {
                type: 'textarea',
                label: '任务描述',
                key: 'remark',
                value: ''
            }
        ]
      }
    }
  },
  methods: {
    cancel() {
      this.resetForm()
    },
    doSubmit(val) {
      this.form = val
      this.doAdd()
    },
    doAdd() {
      add(this.form).then(() => {
        this.resetForm()
        this.$notify({
          title: this.isAdd ? '新增成功' : '修改成功',
          type: 'success',
          duration: 2500
        })
        this.loading = false
        this.supThis.dataTableInit()
      }).catch(() => {
        this.loading = false
      })
    },
    resetForm() {
      this.dialog = false
      this.$refs.pageForm.resetForm()
    }
  }
}
</script>

<style scoped>

</style>
